export const markers = [
  {
    "latitude": -22.937583333333333,
    "longitude": -43.183749999999996,
    "title": "Gritos de Independência",
    "description": "The first video published on the YouTube Channel of MIC in 2013, shows a street protest in September 2013. A resident who was not actively participating at the protests lost consciousness for a moment and fell to the ground, after police bombarded protesters and bystanders with teargas.  ",
    "videoId": "Z-Woh1xSYBc",
    "pubDate": "2013-09-08T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Media",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "gáslacrimogéneo",
      "protesto",
      "violenciapolicial",
      "2013",
      "MIC",
      "direitoaintegridadefísica"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.91033333333333,
    "longitude": -43.17594444444444,
    "title": "ROMPENDO O SILÊNCIO",
    "description": "In an interview, two activists explain in detail how milita (private security) threatened and infiltrated the social movement. They claim that the militas were paid by right wing politicians to terrorize activist and spread fear amongst them. ",
    "videoId": "NXr_U3AEpDE",
    "pubDate": "2013-09-17T04:00:00.000Z",
    "producer": [
      "MIC",
      "Eyewitness (Anonymous)"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "2013",
      "direitoaintegridadefísica",
      "euapoioos23",
      "globo",
      "liberdadedeexpressão",
      "ocupa",
      "protesto",
      "violenciapolicial",
      "segurançaprivada(milícia)"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.93413888888889,
    "longitude": -43.18044444444444,
    "title": "QUEM QUEIMOU A CONSTITUIÇÃO?",
    "description": "The public screening of the Zoro movie is followed by a debate about the criminalization of social movements and the use of masks by activists as a means of protection. The attorney Andre Barros explains the juridical situation in regard to wearing masks during a protest march. ",
    "videoId": "TXoBSDr-0JU",
    "pubDate": "2013-09-27T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "liberdadedeexpressão",
      "protesto"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.910666666666664,
    "longitude": -43.17622222222222,
    "title": "PROFESSORES À PALMATÓRIA \"Aquilo que a televisão não mostrou\"",
    "description": "The video shows the violent repression of protests by teachers and students between 30 September and 1 October 2013. The violent clashes between activists and police are intense. ",
    "videoId": "2MUtki9fZYo",
    "pubDate": "2013-10-03T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Unions",
      "Students",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "balasdeborracha",
      "2013",
      "direitoaintegridadefísica",
      "fora",
      "liberdadedeexpressão",
      "protesto",
      "truculênciadoestado",
      "violenciapolicial",
      "gáslacrimogéneo"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.910666666666664,
    "longitude": -43.17622222222222,
    "title": "1964 Agora.",
    "description": "Short video shows scenes from a protest for improving public education turned violent. In one scene, police officers are shown shooting teargas while moving towards the protester laying on the ground with serious injuries. The video claims that the 2013 movement is facing similar repression like social movements during the military dictatorship, which started 1964 in Brazil. ",
    "videoId": "LCcDlvdryuc",
    "pubDate": "2013-10-10T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "educação",
      "protesto",
      "policeviolence",
      "violenciapolicial",
      "gáslacrimogéneo",
      "ditadura",
      "2013"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910666666666664,
    "longitude": -43.17622222222222,
    "title": "REVOLUÇÃO NÃO CAI DO CÉU",
    "description": "The video portrays the strike for improving public education in the state of Rio de Janeiro on 7. October 2013. At the beginning a multitude of voices from protesters is presented, who explain their reasons for demanding policy changes for public education, before the video shows the violent clashes between police and protesters and the destruction of objects such as ATMs and a bus. ",
    "videoId": "j8M8v7jVNPs",
    "pubDate": "2013-10-14T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Unions",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "professores",
      "protesto",
      "violenciapolicial",
      "gáslacrimogéneo",
      "RionaRua",
      "Mariachi",
      "Projetação"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "TENTATIVA FRUSTRADA DE PRISÃO ARBITRÁRIA",
    "description": "Short video showing how police controls two protesters and attempts to imprison them. The police argue they discovered cartridges with the protesters – a claim refuted by video activist, who point out that the police officer picked up the cartridges from the street. ",
    "videoId": "X5zOeN86hi8",
    "pubDate": "2013-10-16T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "protesto",
      "2013",
      "abusopolicial"
    ],
    "viewCount": "5000 - 10000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Estamos em Guerra?",
    "description": "“We are in war” says the police officer. In a discussion with a citizen, the officer describes protesters as “vagabonds” (pt. vagabond) and “outlaws” (pt. bandido), a discourse commonly used in Brazil 2013 to delegitimize protesters as violent crowds, whose claims can be ignored. ",
    "videoId": "VtAx2V5yFww",
    "pubDate": "2013-10-16T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "protesto",
      "bandido"
    ],
    "viewCount": "10000 and more",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "LEI 12.850: UM CRIME CONTRA A DEMOCRACIA",
    "description": "During the “ocupa camera” on 15 October 2013, police arrested dozens of citizens on the base of the law 12.850, which defines acts of transgressions vague and hence makes detentions a viable practice of policing. ",
    "videoId": "94L0DHHPHE4",
    "pubDate": "2013-10-17T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "2013",
      "desencarceiramento",
      "detenção",
      "euapoioos23",
      "liberdadeparaospresospolíticos",
      "liberdadedeexpressão",
      "ocupa",
      "protesto"
    ],
    "viewCount": "10000 and more",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.90940583333333,
    "longitude": -43.176069444444444,
    "title": "JOGAR PEDRAS É VANDALISMO?",
    "description": "A short video, which shows how a police officer throwing stones at protesters. To reverse the claim that protesters are violent vandals and supported by the images, the video asks, “what is vandalism here”?",
    "videoId": "c0_57KV_GfQ",
    "pubDate": "2013-10-18T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "violenciapolicial",
      "abusopolicial",
      "2013",
      "protesto",
      "truculênciadoestado"
    ],
    "viewCount": "5000 - 10000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "15 de outubro - O dia da truculência",
    "description": "The video shows how a young woman is arrested and taken to prison by police in riot gear in the center of Rio de Janeiro. The arrest is closely followed by a number of video producers, who question the arrest and call for calm. ",
    "videoId": "ArlvaVQW6Cg",
    "pubDate": "2013-10-19T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "detenção",
      "liberdadedeexpressão",
      "protesto",
      "truculênciadoestado"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "FOME: pela libertação do Baiano",
    "description": "A short documentary film, which shows the struggle to free political prisoners and especially “Baiano”. The video shows the hunger strike by two activists, who act in solidarity with Baiano and request his release, as well as archival footage from the previous protests.",
    "videoId": "zRltGH1-fRk",
    "pubDate": "2013-11-26T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "violenciapolicial",
      "2013",
      "desencarceiramento",
      "detenção",
      "direitoaintegridadefísica",
      "euapoioos23",
      "globo",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "ocupa",
      "protesto"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "UM NOVO TEMPO",
    "description": "Looking back on the year 2013 and its protests, a group of activists assembles at Cinelandia to sing and dance together, claiming the streets for the social movement. ",
    "videoId": "TBPcrdjMUVI",
    "pubDate": "2013-12-13T05:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi",
      "Projetação",
      "Coletivo Carranca",
      "Rio na Rua",
      "Ocupa Camera",
      "Linha Frente"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "2013",
      "arte",
      "maisamormenoscapital",
      "ocupa",
      "protesto",
      "vemprarua",
      "Mariachi",
      "Projetação",
      "ColetivoCarranca",
      "RionaRua",
      "LinhaFrente",
      "OcupaCamera"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910724444444444,
    "longitude": -43.22616527777778,
    "title": "Apelo dos Povos Indígenas da Aldeia Maracanã.",
    "description": "A call for solidarity by five women from Aldeia Maracanã, who decry the eviction from their homes. The women also call attention to Urutau Guajajara, who hid in a tree to protect the settlement from the remotion and has been isolated there by security forces without food or water supply for more 24 hours.  ",
    "videoId": "8RABCs4pisQ",
    "pubDate": "2013-12-18T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "AldeiaMaracanã",
      "indigena",
      "direitoamoradia",
      "direitoaintegridadefísica",
      "ocupa",
      "remoção",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.96635722222222,
    "longitude": -43.23701305555556,
    "title": "Passeata da Resistência Contra a Remoção do Horto",
    "description": "The community of Horto with more tha 500 families living there, is threatened to be destroyed. Residents and social movements in solidarity take to the streets to stop the planned eviction and question the politics of removing racialized and lower-income communities form Rio de Janeiro’s wealthy South Zone. ",
    "videoId": "CQB1hyLWKeg",
    "pubDate": "2014-03-27T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "direitoamoradia",
      "protesto",
      "remoção"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.93728972222222,
    "longitude": -43.18394444444444,
    "title": "SOMOS TODOS CLÁUDIA",
    "description": "The video shows a protest march to commemorate Cláudia Silva Ferreira. A black woman and mother of four kids, Claudia was shot by police in her home community when she went out to buy bread. An Eyewitness Video; provoked outrage as it shows how her body was dragged behind a police car for 300 meters. ",
    "videoId": "aa0Uf2gKoxI",
    "pubDate": "2014-04-06T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "protesto",
      "vidasnegrasimportam",
      "abusopolicial",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "policiaassassina",
      "violenciapolicial",
      "paremdenosmatar"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.910128888888888,
    "longitude": -43.18436416666666,
    "title": "Rafucko: Manequins valem mais do que vidas",
    "description": "The video accompanies artist and activist Rafucko to the police station, where he is accused of stealing a plastic mannequin of the Toulon Shop in the centre of Rio de Janeiro. Rafucko comments on the prosecution against him with questioning why crimes committed against protesters and residents of Favelas are not being prosecuted – is the value of a plastic mannequin higher than the lives of people, Rafucko asks.",
    "videoId": "hS8itzSy8IY",
    "pubDate": "2014-04-24T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "arte",
      "genocidio",
      "bastaderacismo",
      "liberdadedeexpressão",
      "protesto",
      "violenciapolicial",
      "ANovaDemocracia",
      "RionaRua",
      "MídiaNinja",
      "Mariachi",
      "Carranca",
      "Vinhetando"
    ],
    "viewCount": "10000 and more",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.90891722222222,
    "longitude": -43.17624138888889,
    "title": "50 Anos do Golpe Militar: permanecemos carregando o entulho autoritário",
    "description": "A protest march on 1. April 2014 in the center of Rio de Janeiro, held to commemorate the 50th anniversary of the beginning of the military dictatorship in Brazil (1964 – 1985). The protesters call out the violent crimes, tortures, and killings committed by the regime then and question the use of violence against protesters today. Violent repression and arrests are seen to take place during the 2014 protest.",
    "videoId": "Z1I-sSRgAyI",
    "pubDate": "2014-04-28T04:00:00.000Z",
    "producer": [
      "MIC",
      "Midia Ninja"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "golpe",
      "demonstration",
      "protesto",
      "MídiaNinja",
      "violenciapolicial",
      "protesto",
      "ditadura",
      "abusopolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.966081944444444,
    "longitude": -43.23466166666667,
    "title": "Sobre a reintegração de posse do Clube do Horto.",
    "description": "Interview with a resident from the Horto community, a century old settlement threatened with evictions. Prior to the protest, residents of the community were injured with rubber bullets. ",
    "videoId": "PF78unhE038",
    "pubDate": "2014-05-06T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Environmental Justice & Climate Crisis",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "protesto",
      "balasdeborracha",
      "direitoamoradia",
      "protesto",
      "balasdeborracha",
      "justiçahambiental",
      "remoção"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.912055555555554,
    "longitude": -43.23013888888889,
    "title": "Civil saca arma de fogo e atira durante Argentina X Bósnia (Maracanã, RJ)",
    "description": "A short video, which shows the confrontation between video activist and a civil police officer around a protest march against the world cup. The officer openly carries his gun and when driving off in a civil car fires warning shots. It is one of the most viewed videos produced by the MIC collective. ",
    "videoId": "HX4uj15TsCY",
    "pubDate": "2014-06-15T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi",
      "Linha Frente"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "2013",
      "violenciapolicial",
      "Mariachi",
      "copa2014",
      "protesto"
    ],
    "viewCount": "10000 and more",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "Monstro",
    "description": "A video, which has been produced by followers of the MIC collective and consequently published. As docu-fiction it mixes real scenes of police violence attacking residents in Favelas and protesters on the street with action movie elements and a gigantic moster to say “Não vai ter copa“ (There is not World Cup to come). ",
    "videoId": "2BIu5HVHPew",
    "pubDate": "2014-06-24T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Other"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "balasdeborracha",
      "2013",
      "chacina",
      "copa2014",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.981527777777774,
    "longitude": -43.18977777777778,
    "title": "As festas nos estádios não valem as lagrimas nas favelas",
    "description": "Following a protest march that descends from Morro da Babilônia on Copacabana beach. Among the protesters the cry to end the divided city and overcome exclusionary and lethally violent policies is repeated and a lot of parents whose children were killed by police, decry the continuing violence against poor and black people from the North Zone and the favelas of the city. ",
    "videoId": "j0f89UljemQ",
    "pubDate": "2014-06-25T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "protesto",
      "violenciapolicial",
      "direitoamoradia",
      "copa2014",
      "chacina",
      "bastaderacismo",
      "genocidio",
      "Mariachi"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.91297222222222,
    "longitude": -43.179944444444445,
    "title": "Advogada é agredida com spray de pimenta por policial do Choque",
    "description": "Short Eyewitness Video; edited with dramatic music, which shows how police officers use pepper spray against lawyers during a protest in the center of Rio de Janeiro. ",
    "videoId": "YPvFSsxsz_s",
    "pubDate": "2014-06-28T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "copa2014",
      "direitoaintegridadefísica",
      "liberdadedeexpressão",
      "protesto",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.91097222222222,
    "longitude": -43.20561111111111,
    "title": "S.O.S Educação",
    "description": "Covering a small protest by teachers, whose salaries were reduced by city mayor Eduardo Paes. The cuts in teachers incomes is contested as unconstitutional and intentionally aims to limit freedom of speech as the protesters argue. ",
    "videoId": "g8LP0JWDJLk",
    "pubDate": "2014-07-11T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Unions"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "direitoaotrabalho",
      "educação",
      "liberdadedeexpressão",
      "professores",
      "protesto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.90891722222222,
    "longitude": -43.17624138888889,
    "title": "Ditadura Nunca Mais!",
    "description": "A interview with the director of the journalist union of Rio de Janeiro, Paula Máiran. In the interview at a protest march, Máiran discusses the limitations of free speech, attacks against journalists, and political imprisonments to compare these tactics by state authorities with tactics employed during the military dictatorship. ",
    "videoId": "O6TMPW3bnOI",
    "pubDate": "2014-07-16T04:00:00.000Z",
    "producer": [
      "MIC",
      "Coletivo Sagaz"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Unions"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "abusopolicial",
      "ditadura",
      "euapoioos23",
      "liberdadedeexpressão",
      "protesto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.905295833333334,
    "longitude": -43.1727625,
    "title": "Liberdade e Anistia já!",
    "description": "A compilation of footage from October 2013 and July 2014, which shows protesters fighting for better public education and health. In October 2013, 70 activists were imprisoned and in July 2014 another 12. The requests the immediate release of the political prisoners. ",
    "videoId": "slmKtPZsWJ4",
    "pubDate": "2014-07-18T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "detenção",
      "educação",
      "euapoioos23",
      "globo",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "professores",
      "protesto",
      "saúde",
      "copa2014"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.907124166666666,
    "longitude": -43.19062361111111,
    "title": "Manifesto pelos Presos Políticos",
    "description": "A video compilation, showing attempts of political repression ranging from imprisonment, the use of non-lethal weapons by police officers, death threats against protesters and attempted forced evictions. The video lets those affected by these attempts speak for themselves and echoes their critiques of silencing dissent. ",
    "videoId": "iVzr8EPGICY",
    "pubDate": "2014-07-22T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi",
      "Projetação",
      "Central de Vídeo Ativismo",
      "Coletivo Sagaz"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "balasdeborracha",
      "2013",
      "AldeiaMaracanã",
      "indigena",
      "detenção",
      "euapoioos23",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "protesto",
      "AmnestyInternational"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.905089999999998,
    "longitude": -43.18123111111111,
    "title": "Depoimentos Exclusivos dos Presos Políticos",
    "description": "The exclusive video of a press conference by part of the 23 political prisoners, sharing their experiences made during incarceration and calling for an end of the process against them. ",
    "videoId": "N2mJiqHYhSU",
    "pubDate": "2014-07-26T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi",
      "Midia Ninja"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "2013",
      "detenção",
      "euapoioos23",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "Mariachi",
      "MídiaNinja"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.914543888888886,
    "longitude": -43.17918583333333,
    "title": "Ativistas falam contra o estado de exceção no Brasil",
    "description": "Interviews with political prisoners, advocates, and politicians, who decry the repressive tactics used against protesters and their imprisonment. The interviewees point out structures of violence against poor and marginalized citizens and similarities in the state strategies to silence protests. ",
    "videoId": "Ts0iojz9EiY",
    "pubDate": "2022-07-30T04:00:00.000Z",
    "producer": [
      "MIC",
      "Rio na Rua"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "ditadura",
      "euapoioos23",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "RionaRua",
      "globo"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.903891666666667,
    "longitude": -43.18734944444444,
    "title": "Ato Nacional 30 de Julho - Liberdade para os Presos Políticos",
    "description": "A protest march in response to the repression of the 2013 protests and consequential imprionments. The video gives voice to individuals and representatives of groups such as the founder of Movimento Sem Teto, the Frente Independente Popular and various others. ",
    "videoId": "71BEk-frc9U",
    "pubDate": "2014-07-31T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "protesto",
      "ditadura",
      "2013",
      "globo",
      "liberdadeparaospresospolíticos",
      "semteto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.96712472222222,
    "longitude": -43.22507027777778,
    "title": "Moradores do Horto realizam protesto artístico no Jardim Botânico",
    "description": "Residents from the working-class neighborhood Horto in Rio’s wealthy south zone protest the planned forced eviction and destruction of their homes. With a public performance at the Jardim Botanico, the residents present their message: “Horto s going to stay!”.",
    "videoId": "rfdFh03yvKw",
    "pubDate": "2014-08-25T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "Horto",
      "direitoamoradia",
      "globo",
      "protesto",
      "remoção",
      "Mariachi"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.9097925,
    "longitude": -43.176470277777774,
    "title": "A luta de um Professor para dar aula aos seus alunos no RJ",
    "description": "Eduardo Papa worked for more than 14 years as teacher in a public school. After participating in the teachers strike in September 2013, he is being fired and loses is job. In the video, Eduardo and his students demand that he can return to his former job as a teacher and claim punishment for going on strike as unconstitutional. ",
    "videoId": "SqafULQNXbo",
    "pubDate": "2014-09-03T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Unions"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "ColetivoSagaz",
      "Mariachi",
      "2013",
      "direitoaotrabalho",
      "educação",
      "liberdadedeexpressão",
      "professores",
      "protesto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.930887,
    "longitude": -43.178705,
    "title": "GM do Rio oprime os tradicionais verdureiros do Largo do Machado",
    "description": "The video shows the aftermath of an intervention by city police against street vendors. The police officers destroyed and took away the vegetable food stands traditionally placed at Largo do Machado and frustrated vendors and bystanders are outraged observing the events, lighting up a burning barricade on the street. A woman from the neighborhood comments sarcastically: “When would they ever dare to do anything like this to the gringos on Copacabana beach?”. ",
    "videoId": "HDBU87u000M",
    "pubDate": "2014-09-18T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "protesto",
      "abusopolicial",
      "direitoaotrabalho",
      "protesto",
      "remoção",
      "Mariachi"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Eduardo Viveiros de Castro declara apoio ao evento 15 de Outubro Nós Não Esqueceremos",
    "description": "The world renown anthropologist Eduardo Viveiros de Castro explains in an interview the importance of the streets as a site for public discourse and defends the right to protest. He argues that the repression and prosecution following the teachers strike form October 2013 goes against basic rights in Brazil. ",
    "videoId": "xwl0V_rlehs",
    "pubDate": "2014-10-14T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "professores",
      "passelivre",
      "educação",
      "2013",
      "copa2014",
      "liberdadedeexpressão"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.908860277777777,
    "longitude": -43.1749425,
    "title": "O marketing da meritocracia",
    "description": "Teacher Eduardo Papa in an interview describes the malfunctions of the public education system in the state of Rio de Janeiro and how current reforms are further aggravating the situation for thousands of pupils. ",
    "videoId": "dUGI_B9MxMg",
    "pubDate": "2014-10-18T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "educação",
      "liberdadedeexpressão",
      "professores"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.93725,
    "longitude": -43.18391222222222,
    "title": "Presente de grego para o novo governador",
    "description": "A protest march that leads to Palacio de Laranjeras, the seat of Rio de Janeiro’s governor, who had just won the second turn of the elections. The present by the group of protesting activists is a Trojan horse, which they handed over to express their frustration with electoral politics in its current state and the claim that “you do not represent us”. ",
    "videoId": "H39FiSCHXVE",
    "pubDate": "2014-10-28T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "protesto",
      "remoção",
      "liberdadeparaospresospolíticos",
      "2013",
      "copa2014",
      "direitoamoradia",
      "educação",
      "liberdadedeexpressão",
      "transportepúblico",
      "ocupa"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.924218333333336,
    "longitude": -43.23213611111111,
    "title": "A Verdade é Filha do Tempo | Caso Andressa",
    "description": "The video shows scenes from the FIFA World Cup 2014 in Rio - during which protesters were arrested by police. The interviews in the video gives voice to one of the prisoners, Alessandra, a student of less than 18 years, and a professor from UFRJ ad representative of the group “torture never again”, talk about the experience of imprisonment and torture. ",
    "videoId": "kfxRCcSRXoY",
    "pubDate": "2014-10-29T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "abusopolicial",
      "copa2014",
      "desencarceiramento",
      "detenção",
      "direitoaintegridadefísica",
      "tortura",
      "violenciapolicial",
      "Mariachi"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.788191944444446,
    "longitude": -42.98271277777778,
    "title": "Ocupação Zumbi dos Palmares: a luta por moradia e a função social da propriedade",
    "description": "Short reportage about an occupation of an empty lot by the MTST movement in São Gonçalvo, Rio de Janeiro State. The interviewees explain their reasons for the occupation and their strategies in claiming empty land mostly used for real estate speculation. ",
    "videoId": "oJnaZeC870s",
    "pubDate": "2014-11-10T05:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoamoradia",
      "ocupa",
      "remoção",
      "semteto",
      "Mariachi"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.91458861111111,
    "longitude": -43.17918583333333,
    "title": "LIBERDADE PARA IGOR MENDES E TODOS OS PRESOS POLÍTICOS",
    "description": "Interview with Igor Mendes, who was arrested in December 2014 and imprisoned for seven months. In the interview before his arrets, Mendes who studied critical geography and was active during the 2013 protests, criticizes the reporting of corporate media like Globo, police attacks against citizens and (lethal) violence against marginalized urban residents. ",
    "videoId": "uJyNSMtaQ9E",
    "pubDate": "2014-12-11T05:00:00.000Z",
    "producer": [
      "MIC",
      "Rio na Rua"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "2013",
      "detenção",
      "liberdadeparaospresospolíticos",
      "RionaRua",
      "globo"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -23.00533861111111,
    "longitude": -43.40763666666667,
    "title": "Ataque ao Ocupa Golfe",
    "description": "Municipal police forces take away the belongings of protesters at the Ocupa Golfe camp. The activists from the small scale ocupation claim that among the personal belongings taken from them is a key to their car. The police officers ignore their claims and when the activists peacefully try to stop the police car from leaving, police officer use force and arrest one of the activists. ",
    "videoId": "OmruSK02jZ0",
    "pubDate": "2014-12-22T05:00:00.000Z",
    "producer": [
      "MIC",
      "Ocupa Golfe"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Environmental Justice & Climate Crisis",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "detenção",
      "direitoaintegridadefísica",
      "liberdadedeexpressão",
      "ocupa",
      "protesto",
      "remoção",
      "violenciapolicial"
    ],
    "viewCount": "10000 and more",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Mais Amor, Menos Capital 2014",
    "description": "In December 2014 people organize for festivities labeled “Mais amor, menos capital” (more love, less capital). The festivities invite especially people living in a situation of homelessness and their children. In a public discussion session after the chrildrens’ party with clowns, the repression and political imprisonment is denounced.  ",
    "videoId": "h7nfqewmeLs",
    "pubDate": "2014-12-25T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "maisamormenoscapital",
      "2013",
      "direitoamoradia",
      "euapoioos23",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "ocupa"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "MÃOS AO ALTO! 3.40R$ É UM ASSALTO!",
    "description": "Typical documentation of a peaceful protest that decries the rising costs for public transport. The manifestation says “3,40 is robbery” pointing to the planned public transport cost hikes. ",
    "videoId": "xJznWA22Pn0",
    "pubDate": "2015-01-06T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "liberdadeparaospresospolíticos",
      "passelivre",
      "protesto",
      "transportepúblico"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -23.00532861111111,
    "longitude": -43.407615,
    "title": "GUARDA MUNICIPAL DO RIO ATACA AMBIENTALISTAS",
    "description": "Video shows guarda municipal officers removing a structure erected by Ocupa Golfe activists and violent attacks against them. The attacks include beating, breaking a teeth of an activist and making arrests.",
    "videoId": "1pw4VEc6kZ8",
    "pubDate": "2015-01-07T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Environmental Justice & Climate Crisis",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "protesto",
      "violenciapolicial",
      "abusopolicial",
      "detenção",
      "direitoaintegridadefísica",
      "justiçahambiental",
      "ocupa",
      "remoção"
    ],
    "viewCount": "10000 and more",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "ATO DO MPL-RJ CONTRA O AUMENTO DAS PASSAGENS E PELA LIBERDADE DOS PRESOS POLÍTICOS",
    "description": "The protest against the increase of public transport fees brings together activists that demand free public transport, the liberation of the political prisoners, and improving public health services. At the march Batman Rico is spotted and expulsed by activists due to his relation with right-wing politician Jair Bolsonaro. ",
    "videoId": "wOCZFcsZ0bw",
    "pubDate": "2015-01-10T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "euapoioos23",
      "protesto",
      "violênciapolicial",
      "AldeiaMaracanã",
      "saude",
      "fora",
      "liberdadeparaospresospolíticos",
      "passelivre",
      "transportepúblico",
      "vemprarua",
      "gáslacrimogéneo"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "ENTREVISTA COM MARINO D' ICARAY - 1 °PARTE",
    "description": "Interview with an attorney Marino D'Icarahy defending political prisoners. The attorney argues that the juridical process against the activists is part of a wider strategy to “criminalize poor people, black people, and social movements”.",
    "videoId": "FwbDVGZ5pas",
    "pubDate": "2015-01-12T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "euapoioos23",
      "liberdadeparaospresospolíticos",
      "2013"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.908121666666666,
    "longitude": -43.20086777777778,
    "title": "3° Ato do MPL - RJ",
    "description": "This protest march against the rise of public transport costs in January 2015 focused not only on the right to the city, but to basic citizenship rights of not being imprisoned ad prosecuted as political activist. Ironically, the peaceful protest ends with police arresting another protester and using tear gas and baton sticks to disperse the crowd. ",
    "videoId": "N3KOrYD3xhQ",
    "pubDate": "2015-01-18T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "euapoioos23",
      "passelivre",
      "protesto",
      "detenção",
      "educação",
      "liberdadeparaospresospolíticos",
      "transportepúblico",
      "gáslacrimogéneo",
      "Mariachi"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -23.539338333333333,
    "longitude": -46.57198027777778,
    "title": "3º ACT AGAINST THE INCREASE OF TICKETS - SP",
    "description": "The video shows a protest march of circa 8’000 people in São Paulo, who demand free and public transport for all. A claim widely supported by the Movimento Passa Livre across Brazilian cities. ",
    "videoId": "p0_wFAaJ-Tk",
    "pubDate": "2015-01-22T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "passelivre",
      "protesto",
      "liberdadeparaospresospolíticos",
      "transportepúblico"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.906971388888888,
    "longitude": -43.18206,
    "title": "CIDADE MARAVILHOSA SQN - VERSÃO MIC",
    "description": "A mockery of the song “cidade maravilhosa” that assembles video nippets from protests and police violence recorded since 2013. ",
    "videoId": "Zn-4k1OzaNQ",
    "pubDate": "2015-02-13T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Environmental Justice & Climate Crisis",
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Unions",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "2013",
      "ocupa",
      "protesto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.853202777777778,
    "longitude": -43.246789722222225,
    "title": "Rebelião no Complexo da Maré - RJ",
    "description": "The video shows a the “protest for life” at the Favela Complexo da Maré. The peaceful protest escalates, when police use tear gas to disperse the crowd from the street and then fire with lethal ammunition towards people. The march was organized in response to a series of police assassinations in Rio’s favelas in the previous weeks. ",
    "videoId": "vH0r460o3_c",
    "pubDate": "2015-02-25T05:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "protesto",
      "vidasnegrasimportam",
      "violenciapolicial",
      "gáslacrimogéneo"
    ],
    "viewCount": "10000 and more",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.930673055555555,
    "longitude": -43.17871361111111,
    "title": "PELO FIM DO GENOCÍDIO NAS FAVELAS",
    "description": "After 10 year-old Eduardo Jesus was killed by police officers with a shot into his head, a protest march is organized to demand an end to the “genocide of the youth in Favelas” for whom the Pacifying Police (Upp) is blamed. The protest march leads the crowd to a building that has been occupied in the same week and now houses several dozen citizens. ",
    "videoId": "L87B4kZGXo4",
    "pubDate": "2015-04-12T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "genocidio",
      "bastaderacismo",
      "ocupa",
      "direitoamoradia",
      "direitoaintegridadefísica",
      "protesto",
      "violenciapolicial",
      "policiaassassina"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.974101,
    "longitude": -43.402578,
    "title": "Vila Autódromo - Depoimentos dos moradores agredidos pela prefeitura",
    "description": "The forced eviction of a complete community - Vila Autódromo - is part of the legacy of the Olympic Games 2016. In this short documentary, frustrated and injured residents share their experiences of being forced out of their houses that are going to be demolished. ",
    "videoId": "M8NNsZR-nnI",
    "pubDate": "2015-06-09T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "balasdeborracha",
      "direitoamoradia",
      "ocupa",
      "remoção",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.97372611111111,
    "longitude": -43.40236361111111,
    "title": "Na Maré da Copa",
    "description": "A documentary, which follows everydaylife in the favela Complexo da Maré during the FIFA Football Worldcup in 2014. The documentary argues that the lasting and devastating effects of the tournament are not the seven-one loss by the Brazilian national team, but the militarization of residential areas across the country. ",
    "videoId": "0jxVKCclYPM",
    "pubDate": "2015-08-03T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "copa2014",
      "euapoioos23",
      "genocidio",
      "copa2014",
      "protesto",
      "violenciapolicial"
    ],
    "viewCount": "5000 - 10000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.94728,
    "longitude": -43.111818,
    "title": "IMBUHY - DA BANDEIRA À REMOÇÃO - DOCUMENTÁRIO COMPLETO",
    "description": "A full feature documentary about the eviction of a fishing community in Niteroi.",
    "videoId": "vrCcOywjKVM",
    "pubDate": "2015-08-04T04:00:00.000Z",
    "producer": [
      "MIC",
      "CMI-Rio"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "violênciapolicial",
      "vidaspretasimportam",
      "corrupção",
      "direitoamoradia",
      "protesto",
      "remoção",
      "semteto"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -12.122859444444446,
    "longitude": -58.00071666666667,
    "title": "Indígena Enawenê Nawê é baleado no Mato Grosso",
    "description": "The Eyewitness Video; chronicles the turbulence in a clash between fazenda owners and truck drivers on the one side and the indigenous of Enawenê on the other side. The situation escalates and a man, Daliameali Enawenê-Nawê, is shot in his chest. ",
    "videoId": "jp45FOCHwd8",
    "pubDate": "2015-10-25T04:00:00.000Z",
    "producer": [
      "Eyewitness (Anonymous)"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "protesto",
      "genocidio",
      "indigena"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.930623611111113,
    "longitude": -43.17869222222222,
    "title": "Denúncia de trabalho escravo no Bob's",
    "description": "Former employee of the food chain Bob is protesting in front of a restaurant. He denounces the “slave” like working conditions. ",
    "videoId": "INKIsBrQFro",
    "pubDate": "2015-11-04T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Unions"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoaotrabalho",
      "protesto"
    ],
    "viewCount": "10000 and more",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "80 PRATAS",
    "description": "An intimate conversation, where Marcelo (fictional name) tells the story how he came from running a career at an insurance company, to losing first both his parents and then his job and his home. The short interview reflects on the living conditions for people without homes in Rio’s center and the threats they endure from police. ",
    "videoId": "oZzGcxgdiZQ",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "semteto",
      "remoção",
      "direitoamoradia",
      "abusopolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.948557222222224,
    "longitude": -43.366257222222224,
    "title": "Prefeitura queima barraco com criança dentro!",
    "description": "Interviews with residents from Frente Internacionalist do Sem Teto recount the forced removal from their newly barracks by state officials. The forced eviction in Jacarepaguá, Cidade de Deus, apparently included the use of pepper spray against residents and violent intrusion in the presence of kids. ",
    "videoId": "M8XtQQ8SBA8",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoamoradia",
      "remoção",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.916456,
    "longitude": -43.182046,
    "title": "Ocupações da FIST sofrem risco de despejo.",
    "description": "Second video in the series produced in collaboration with FIST (Frente Internacionalist do Sem Teto). The interviewees explain the current threats of being displaced from the occupied houses after the government has handed out eviction orders to clear the houses for reconstructing hostels and hotels for tourists. ",
    "videoId": "Z_X6Cbl-ROI",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoamoradia",
      "remoção"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "15 DE OUTUBRO: NÓS NÃO ESQUECEREMOS! AULA PÚBLICA - parte 1",
    "description": "On the public square of Cinelândia in Rio’s center an event was organized to memorize the repression of social movements and the imprisonment of political activists. The event was organized on 15 October 2015 to remind of the anniversary of the large scale police intervention, which lead to 280 detentions, 78 imprisonments, and numerous injured.",
    "videoId": "_E2qxxQYxnw",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "abusopolicial",
      "2013",
      "genocidio",
      "bastaderacismo",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.879739722222222,
    "longitude": -43.253770833333334,
    "title": "UPP E MORTE - A MILITARIZAÇÃO QUE SÓ A FAVELA CONHECE.",
    "description": "“Indifference kills as well,” says Ana Paula, mother of Jhonata, her 9 year-old son who was killed in 2014. Together with other mothers who lost their kids to police assassinations, Ana Paula on that day went to the court of Justice to question the impunity of police killing black youth from Favelas.",
    "videoId": "8S88ZB80MGI",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "policiaassassina",
      "paremdenosmatar",
      "genocidio",
      "bastaderacismo"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.905331944444445,
    "longitude": -43.172797777777774,
    "title": "UPP E MORTE - A MILITARIZAÇÃO QUE SÓ A FAVELA CONHECE.",
    "description": "“Unfortunately, my son was not the first and not the last” says Fátima and then continues to list the teenagers killed in her Favela Manguinhos in the recent months and years. It is a long list of teenage deaths since the Pacifying Police arrived to her neighborhood.",
    "videoId": "SAZ9G08AnMA",
    "pubDate": "2015-11-05T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "policiaassassina",
      "paremdenosmatar",
      "genocidio",
      "bastaderacismo"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.9066525,
    "longitude": -43.17816472222222,
    "title": "Após ato solitário, ex-Bob’s-escravo, consegue apoio para continuar na luta",
    "description": "A short video showing the protest against the working conditions at the restaurant chain Bob’s, which follows the earlier protest few weeks earlier at Largo do Machado. ",
    "videoId": "czuTFGFSwiI",
    "pubDate": "2015-11-08T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Other"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "protesto",
      "direitoaotrabalho"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -23.001910277777778,
    "longitude": -43.32176611111112,
    "title": "Manifestantes fazem escracho na sede da Vale no Rio",
    "description": "Following the catastrophic dam break at Mariana and the environmental destruction of Rio Doce, a protest is organized in front of the headquarters of one of the corporations responsible for the disaster: Vale. During the protest a lot of creative tactics to mourn the environmental disaster are used and a team of reporters from Globo is expulsed from the crowds by activists. ",
    "videoId": "31zcNjEyOh4",
    "pubDate": "2015-11-17T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Environmental Justice & Climate Crisis",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "desastreambiental",
      "justiçahambiental",
      "globo",
      "protesto",
      "Vale"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Fora Cunha e Fora Dilma",
    "description": "During a protest at Cinelandia, which calls for the ouster of conservative politician Eduardo Cunha (“Fora Cunha”) and president Dilma Roussef (“Fora Dilma”), two street vendors share their frustration in an interview. The experience of poverty and the lack of support - despite their hard work - creates a situation of hopelessness for them. ",
    "videoId": "fR881bb0jLk",
    "pubDate": "2015-11-17T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "protesto",
      "fora",
      "direitoaotrabalho"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.927119166666667,
    "longitude": -43.19924722222222,
    "title": "BOPE PROMOVE TERRORISMO NA COMUNIDADE DO FALLET RIO DE JANEIRO",
    "description": "A series of interviews with residents from the Fallett Favela in Rio de Janeiro after a police rush on a party lead to numerous injured residents and one death. Due to fears of repercussions for speaking out, the faces of interviewees are blurred. The collectives claim that not a single news outlet reported on the events. ",
    "videoId": "61jSX0D2ytg",
    "pubDate": "2015-11-19T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "policiaassassina",
      "violênciapolicial",
      "paremdenosmatar",
      "genocidio",
      "direitoaintegridadefísica",
      "Mariachi"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.904592777777776,
    "longitude": -43.234138055555555,
    "title": "Prefeitura rouba trabalhadores na Favela Metrô-Mangueira",
    "description": "“Because we are poor, black, and live in a favela we suffer constant discrimination” says Renata. In an interview with Renata as well as Rosa and her kids, the two black woman  living in the favela Metrô-Mangueira detail their frustration of even being stopped from work by public authorities. ",
    "videoId": "JSBty7GYQGg",
    "pubDate": "2015-11-22T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoaotrabalho",
      "bastaderacismo"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -20.308140277777778,
    "longitude": -40.28843083333333,
    "title": "Surfistas cercam Vale do Rio Doce em Vitória Espírito Santo",
    "description": "Video showing a line of cars with surfboards on top, who are apparently protesting by honking their horns. ",
    "videoId": "SFmBd1bDgWQ",
    "pubDate": "2015-11-27T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Environmental Justice & Climate Crisis"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "desastreda",
      "Vale"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "Policiais executam 5 jovens e tentam forjar auto de resistência",
    "description": "The Eyewitness Video; documents the crime scene. A white car with the corpses of four teenagers inside. Police officers had opened fire on the car and a motorbike without warning, firing 111 shots and killing five teenagers on their way home. ",
    "videoId": "pJx0trcHLZY",
    "pubDate": "2015-11-30T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "Eyewitness"
    ],
    "viewCount": "10000 and more",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.87631388888889,
    "longitude": -43.33517444444445,
    "title": "Pelo fim do genocídio do Povo Negro",
    "description": "“The favela is not going to be quite” shouts Ana Paula to a crowd touched by her speech about the assassination of her son by police. A protest march in Rio, that demands the end of the “genocide” against poor and black people residing in Favelas. A march that follows after another lethal attack on five teenagers.",
    "videoId": "V3tZzju_4ZU",
    "pubDate": "2015-12-04T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "paremdenosmatar",
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "policiaassassina",
      "protesto"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.950731666666666,
    "longitude": -43.11277527777778,
    "title": "Moradora do Imbuhy perde sua casa para o Exército!",
    "description": "Short video that shows a woman and resident from the Imbuhy community in a car, where she expresses her frustration and anger after being evicted from her home. ",
    "videoId": "LRl8QVhOSjo",
    "pubDate": "2015-12-08T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Environmental Justice & Climate Crisis",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "direitoamoradia",
      "remoção"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.904592777777776,
    "longitude": -43.234138055555555,
    "title": "Choque entra na Favela Metrô-Mangueira atirando a esmo!",
    "description": "Video with two black women living in the Favela Metrô-Mangueira. They describe in detail how police entered their neighborhood at 8pm, firing live ammunition on the streets and using pepper spray against the women hiding in a bar. During the violent raid, children were around and in danger as the interviewees emphasize. ",
    "videoId": "xtzu8VozBAk",
    "pubDate": "2015-12-15T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "gáslacrimogéneo",
      "violenciapolicial",
      "vidasnegrasimportam",
      "direitoaintegridadefísica"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.904592777777776,
    "longitude": -43.234138055555555,
    "title": "Eu não quis!",
    "description": "Ruan’s mother Gabriela gives an interview to MIC to right some misinformation spread by media. She argues that the death of her son and her statements were strongly misinterpreted by journalists and included made-up facts. ",
    "videoId": "319I2HAkiXk",
    "pubDate": "2015-12-15T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "vidaspretasimportam",
      "paremdenosmatar"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.941905555555557,
    "longitude": -43.362185833333335,
    "title": "Uma criança e um adolescente mortos em chacina na Cidade de Deus",
    "description": "The Eyewitness Video; footage shows the scene around the killing of 11 year-old and 17 year-old teenager in the Cidade de Deus (City of God) community. ",
    "videoId": "hyVMI7jJ6mI",
    "pubDate": "2015-12-24T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "paremdenosmatar",
      "genocidio",
      "globo",
      "policiaassassina",
      "violenciapolicial",
      "vidasnegrasimportam"
    ],
    "viewCount": "2000 - 5000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.941905555555557,
    "longitude": -43.362185833333335,
    "title": "Meu irmão tem 14 anos!",
    "description": "The sister of 14 year-old Breno de Souza holds a passionate speech in which she laments the killing if her brother as well as the misinformation spread about him in the media. She insists that her brother was 14 years and not 17 years, when he was killed. And he had nothing to do with drug trafficking as media indicated, which is commonly used as an excuse for extra juridical assassinations of black youth from Favelas.  ",
    "videoId": "JJTmcX5ElAg",
    "pubDate": "2016-01-07T05:00:00.000Z",
    "producer": [
      "MIC",
      "Midia1508"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "paremdenosmatar",
      "segurançaprivada(milícia)"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.902895833333332,
    "longitude": -43.19172083333333,
    "title": "P2 JOGA SPRAY DE PIMENTA EM REPÓRTER DURANTE ATO CONTRA AUMENTO DA PASSAGEM",
    "description": "A short Eyewitness Video; that documents how a journalist is attacked with pepper spray during a protest.",
    "videoId": "lqMRzgGWDQQ",
    "pubDate": "2016-01-11T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "violenciapolicial",
      "gáslacrimogéneo"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.902895833333332,
    "longitude": -43.19172083333333,
    "title": "Mídia Ativista é agredido por PMs em ato no Rio de Janeiro",
    "description": "The video documents attacks on activists and independent journalists by police officers in riot gear. The attacks happened during the second protest march against rising public transport costs in 2016. ",
    "videoId": "RvfoNfshXEI",
    "pubDate": "2016-01-16T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "protesto",
      "violenciapolicial",
      "passelivre",
      "transportepúblico"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Manifestação contra o aumento das passagens: tempestade não tira o povo das ruas",
    "description": "The protest against rising public transport costs is covered in this video, which assembled a significant crowd amidst the rain. “Nobody is listening”, complains one of the interviewed street vendors. ",
    "videoId": "A8P7tcTsu74",
    "pubDate": "2016-01-16T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights",
      "Transporte público gratuito e de qualidade"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "protesto",
      "violenciapolicial",
      "transportepúblico"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.90565361111111,
    "longitude": -43.187436111111104,
    "title": "Tiros no grafitaço",
    "description": "The Eyewitness Video; shows attacks against protesters by private security. One of the security guards is shown shooting his gun deliberately towards protesters and attacking journalists. ",
    "videoId": "Mgnt_KXdbTg",
    "pubDate": "2016-02-04T05:00:00.000Z",
    "producer": [
      "MIC",
      "2V"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Lethal Violence"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Media",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "liberdadedeexpressão",
      "protesto",
      "direitoaintegridadefísica",
      "policiaassassina",
      "violenciapolicial",
      "segurançaprivada(milícia)",
      "2V"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -20.502707222222224,
    "longitude": -54.61412138888889,
    "title": "Mato Grosso do Sul: polícia militar reprime com violência diversão de jovens",
    "description": "A video report from Campo Grande, which shows how a student was injured by police using tear gas and pepper spray. The footage shows the immediate aftermath and how police is trying to stop journalist and MIC member, Carlos Augusto Lima França from covering the police attack. ",
    "videoId": "9N9K0ePxeOk",
    "pubDate": "2016-03-10T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Police brutality"
    ],
    "theme": [
      "Citizenship & Human Rights",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "abusopolicial",
      "balasdeborracha",
      "detenção",
      "liberdadedeexpressão",
      "violenciapolicial",
      "gáslacrimogéneo"
    ],
    "viewCount": "5000 - 10000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -23.561512222222223,
    "longitude": -46.65597861111111,
    "title": "PT e PSDB são farinha do mesmo saco e o povo sabe disso",
    "description": "A video showing the politicians Aécio and Alckmin (PSDB) in a crowd of protesters. They are insulted by the crowd. ",
    "videoId": "1ClYdurQlrk",
    "pubDate": "2016-03-14T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Other"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "fora",
      "vemprarua"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -15.799515833333333,
    "longitude": -47.86417361111111,
    "title": "Web-série expõe a máfia dos planos de saúde e o lobby praticado no Congresso Nacional",
    "description": "A video reporting produced in collaboration with the “Movimento Chega de Descaso” (Movement Stop the Neglect), which struggles for improving public health. The video accompanies activists of the movement during their trip to Brasilia, where they encounter politicians and show how their voting on cutting public health expenditures is connected to receiving funding from private health companies. In the end the video shows the consequences of cutting public health by interviewing patients in front of a public hospital, who wait for more than seven hours and do not receive drugs for treatment. ",
    "videoId": "maiO6ykHF_A",
    "pubDate": "2016-05-03T04:00:00.000Z",
    "producer": [
      "MIC",
      "Movimento Chega de Descaso"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "saúde",
      "corrupção",
      "direitoaintegridadefísica",
      "Chegadedescaso",
      "direitoaintegridadefísica",
      "descaso"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.906622777777777,
    "longitude": -43.17814305555555,
    "title": "SAÚDE NÃO É MERCADORIA! CHEGA DE DESCASO! 1° Episódio",
    "description": "The video mixes found footage with scenes from a protest for improving public health ans was produced in collaboration with “Movimento Chega de Descaso” (Movement Stop the Neglect) and Central de Communicação Popular. The narrative shows how disinvestment in public health and support for privatized health structures is linked to funding provided for candidates and political parties on all government levels.  ",
    "videoId": "E8hRumcC-iU",
    "pubDate": "2016-05-09T04:00:00.000Z",
    "producer": [
      "MIC",
      "Movimento Chega de Descaso",
      "Others"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "Chegadedescaso",
      "CentralDeCommunicaçãoPopular",
      "saúde",
      "protesto",
      "direitoaintegridadefísica",
      "descaso"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.79240805555556,
    "longitude": -43.173903055555556,
    "title": "OCUPA MENDES RESISTE BRAVAMENTE AOS ATAQUES E DEPREDAÇÕES DOS DESOCUPAS(ASSISTA ÀS IMAGENS)",
    "description": "A short Eyewitness Video;, which documents the violent attacks on pupils from #OcupaMendes. An occupation of schools, which was part of a large student’s movement in 2016. According to MIC, the group that threatens the school members with violence is linked to parts of the state. ",
    "videoId": "5cn56wA9Dhg",
    "pubDate": "2016-05-16T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "ocupa",
      "direitoaintegridadefísica",
      "educação",
      "ocupaescolas",
      "Eyewitness"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.91255972222222,
    "longitude": -43.18339722222222,
    "title": "Apoio ao Mídia Ativista e Jornalista França.",
    "description": "In an interview journalist and media activist França explains the importance and the approach of contemporary media activism and asks for support after his camera and equipment was stolen. ",
    "videoId": "9dXx5lX5RK0",
    "pubDate": "2016-05-29T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "liberdadedeexpressão"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.93725,
    "longitude": -43.18392305555555,
    "title": "ATO \"A NOSSA LUTA UNIFICOU! É FUNCIONÁRIO, ESTUDANTE E PROFESSOR!\"",
    "description": "The video covers a protest by students and teachers demanding better public education. ",
    "videoId": "UwkZl82GQSA",
    "pubDate": "2016-06-03T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoaotrabalho",
      "educação",
      "professores",
      "protesto",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.90659583333333,
    "longitude": -43.17674805555556,
    "title": "Ocupa SEEDUC",
    "description": "Students occupy the secretariat of education of the state of Rio de Janeiro. They are protesting the lack of funding for and the miserable conditions in public schools. ",
    "videoId": "_sGKdcb2QI0",
    "pubDate": "2016-06-06T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Students"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "educação",
      "liberdadedeexpressão",
      "ocupaescolas",
      "ocupa",
      "protesto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.90217472222222,
    "longitude": -43.27415888888889,
    "title": "Milícia legalizada reprime estudantes no Rio de Janeiro",
    "description": "Students at a protest in the North Zone of Rio de Janeiro lament the violence by privatized police forces. ",
    "videoId": "wxTZccPcSOI",
    "pubDate": "2016-06-11T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Students"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "protesto",
      "abusopolicial",
      "educação",
      "liberdadedeexpressão",
      "ocupaescolas",
      "violenciapolicial",
      "segurançaprivada(milícia)"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.905440833333333,
    "longitude": -43.172797777777774,
    "title": "2° Ato Contra o Genocídio do Povo Negro no Rio de Janeiro",
    "description": "The protest against the “genocide” of Afrobrazilians in Favelas gathers around a performance, which symbolically memorizes the five teenagers killed by 111 bullets fired by police officers. In an interview the father of a 2 year-old baby killed by police decries the lack of justice. ",
    "videoId": "-k6_oBBTCPQ",
    "pubDate": "2016-07-05T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Artistas"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "arte",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "protesto",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.914537222222222,
    "longitude": -43.19731888888889,
    "title": "No Leblon a PM não se confunde",
    "description": "Mixing original eyewitness footage with an interview and compilation of press coverage, the video tells the story of the assassination of Jhonata. He was killed in a Favela by police officers, when he went out to get popcorn from his aunt for a birthday party. Not a single case as the video claims, because police officers in Favelas too often confuse any object with weapons or drugs when killing residents. ",
    "videoId": "bFIKP-IWnm8",
    "pubDate": "2016-07-21T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -15.799515833333333,
    "longitude": -47.86417361111111,
    "title": "Web-série expõe a máfia e o lobby dos planos de saúde no Congresso Nacional",
    "description": "The report investigates the state of public and private health policies in Brazil. The video proposes a strong correlation between the massive spending of private health providers to political parties and candidates on the one side and a lack of funding for public health on the other side. ",
    "videoId": "ZNfdVefwlZQ",
    "pubDate": "2016-09-22T04:00:00.000Z",
    "producer": [
      "MIC",
      "Movimento Chega de Descaso",
      "PRETO Filmes"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Unions"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "saúde",
      "descaso",
      "corrupção",
      "Chegadedescaso",
      "pretofilmes"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.94617277777778,
    "longitude": -43.256925,
    "title": "Denúncia contra a administração de Eduardo Paes",
    "description": "A video which claims to show how construction works on public land are part of a corruption scheme that involves mayor Eduardo Paes. ",
    "videoId": "7sXXkv00tMM",
    "pubDate": "2016-10-12T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "corrupção"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "ATO CONTRA PEC 241 - Das Redes para as Ruas RJ - Vídeo completo",
    "description": "Covering the protest against the PEC241 - a law by the neoliberal Temer government that aimed at cutting public spending massively - the video shows a peaceful protest march, which culminates in violence after the Military Police intervene. ",
    "videoId": "ngT1NqVGfZo",
    "pubDate": "2016-10-18T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights",
      "Racial Justice & Indigenous Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Unions",
      "Police",
      "Media",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "detenção",
      "direitoaintegridadefísica",
      "educação",
      "liberdadedeexpressão",
      "protesto",
      "truculênciadoestado",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.9064075,
    "longitude": -43.17639416666666,
    "title": "Ni Una Menos - Rio de Janeiro",
    "description": "The protest march “Ni una menos” stands in for women and their basic rights - from increasing salaries to equal those of man, to basic security and protection against sexual violence, the ",
    "videoId": "svpKs2r9nos",
    "pubDate": "2016-10-27T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "NiUnaMenos",
      "Nenhumaamenos",
      "genocidio",
      "bastaderacismo",
      "protesto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.759629166666667,
    "longitude": -43.449085277777776,
    "title": "Vídeo: \"Dia de Mobilizações na Baixada-RJ – Contra a PEC do Fim do Mundo\"",
    "description": "A protest march in Baixada Fluminese, which shows resistance against the law PEC55 by students and teachers from public schools and universities. ",
    "videoId": "vd30YAb1JtQ",
    "pubDate": "2016-11-11T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Unions",
      "Students",
      "Media"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "protesto",
      "educação",
      "ocupaescolas",
      "ocupa"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "|| O que não te contaram sobre a Reforma da Previdência ||",
    "description": "A video by ANFIP that uses animations to challenge the previewed reform of the state pension system. ",
    "videoId": "RXgFHwER_eY",
    "pubDate": "2016-12-09T05:00:00.000Z",
    "producer": [
      "ANFIP"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "reformadaprevidência"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.91088361111111,
    "longitude": -43.226255,
    "title": "Aldeia Maracanã Convida!",
    "description": "Short video interview with Urutau Guajajara from Aldeia Maracanã, who offers an invitation to come to the community and learn from indigenous knowledge and practices. ",
    "videoId": "g7BasJqXUw4",
    "pubDate": "2017-01-30T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "AldeiaMaracanã",
      "indigena",
      "justiçahambiental"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -3.7344186111111113,
    "longitude": -38.65570861111111,
    "title": "Etnia Tapeba realiza manifestação pela demarcação de suas terras no Ceará",
    "description": "The video shows a speech by Weiba Tapeba, president of the association ACITA. He declares that they have successfully managed to secured territory for their indigenous community, the Tapeba in the state of Ceará. ",
    "videoId": "KGEV2zK3edo",
    "pubDate": "2017-02-15T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Evictions"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Environmental Justice & Climate Crisis",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "indigena",
      "demarcaçãojá",
      "direitoamoradia",
      "justiçahambiental"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -23.473780833333333,
    "longitude": -46.670428055555554,
    "title": "Assassinato no Habib's: vídeo do protesto pela morte da criança João Victor Souza de Carvalho",
    "description": "Video of a protest that mourns the death of 13 year-old João Victor in São Paulo. João was found dead after private security had removed him from the fast-food restaurant Habib’s. The mother and other protesters decry the racism as João is one of the many cases of black teenagers killed in Brazil every day. ",
    "videoId": "8-RDjTyLZpo",
    "pubDate": "2017-03-03T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Students"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "segurançaprivada(milícia)",
      "Eyewitness",
      "vidasnegrasimportam",
      "protesto",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "bastaderacismo"
    ],
    "viewCount": "5000 - 10000",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.90399638888889,
    "longitude": -43.228706111111116,
    "title": "Ativistas denunciam maus tratos a animais no Zoológico do Rio de Janeiro",
    "description": "At a protest for animal rights, one of the organizers explains the cause and demands they are mobilizing for. ",
    "videoId": "kCuB8eFfDso",
    "pubDate": "2017-03-03T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Environmental Justice & Climate Crisis"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "protesto",
      "justiçahambiental",
      "direitodosanimais"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Entrevista com professor em ato contra a reforma da previdência",
    "description": "Interview with a teacher at a protest rally, who demands improving pension schemes for the millions of public school teachers in Brazil. ",
    "videoId": "jce741ZM9y8",
    "pubDate": "2017-03-21T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Other"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Unions",
      "Students"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "direitoaotrabalho",
      "educação",
      "professores",
      "protesto",
      "violenciapolicial",
      "protesto",
      "reformadaprevidência"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.910585555555553,
    "longitude": -43.17623416666667,
    "title": "Entrevista com Marta Machado sobre a reforma da previdência",
    "description": "A young mother explains the injustice of the planned reform of pension system that further deepens the gender gap in pensions. The activist demands that president Temer leaves office. ",
    "videoId": "jsL9v9MytyU",
    "pubDate": "2017-03-21T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "reformadaprevidência",
      "fora",
      "protesto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -22.719865555555554,
    "longitude": -43.523448055555555,
    "title": "Um trem para Austin - O caso Matheus",
    "description": "The award-winning short documentary, which tells the story of Matheu’s assassination by police on a train. On his way home to Austin, North of Rio de Janeiro, the 18 year-old was beaten and then shot from short distance by police. The testimony of the parents shows the horrors such a loss has families left behind. ",
    "videoId": "FF3nD9od6nI",
    "pubDate": "2017-04-01T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Citizenship & Human Rights",
      "Racial Justice & Indigenous Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "Lula Golbery Odebrecht da Silva",
    "description": "A documentary about president Lula Golbery Odebrecht da Silva and his political career. ",
    "videoId": "1KzrC8l6kRU",
    "pubDate": "2017-04-15T04:00:00.000Z",
    "producer": [
      "MIC, Mariachi"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Unions"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "ditadura"
    ],
    "viewCount": "10000 and more",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.905371388888888,
    "longitude": -43.17273333333333,
    "title": "Rafael Braga - O homem que foi condenado por porte de pinho sol",
    "description": "A documentary about Rafael Braga, one of the most famous victims of state prosecution in the last decade in Rio de Janeiro. Rafael Braga was detained and convicted to prison for carrying a bottle of bleach and disinfectant, which he used as street vendor. He was convicted for being around during the popular protests in 2013. ",
    "videoId": "XzCaJwFnljI",
    "pubDate": "2017-04-22T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "2013",
      "bastaderacismo",
      "desencarceiramento",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "rafaelbraga",
      "protesto"
    ],
    "viewCount": "10000 and more",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.908901666666665,
    "longitude": -43.17361333333333,
    "title": "Um ano Ocupa MINC",
    "description": "One year after a series of occupations began, artists and activist come together to celebrate OcupaMINC and emphasize their criticism against corruption, violence against residents form Favelas, and the political crisis. ",
    "videoId": "TrWdeYdzH9w",
    "pubDate": "2017-05-17T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "arte",
      "corrupção",
      "ocupa",
      "protesto",
      "fora"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.903555555555553,
    "longitude": -43.18949083333333,
    "title": "Filme realizado pela MIC é premiado no Festival Mate Com Angu",
    "description": "Award ceremony at the Festival Mate com Angu de Cinema Popular for a short film by MIC. The short film “Um Trem para Austin” recounts the killing of Matheus Ervandre by Military Police in a subway train of Rio de Janeiro. In their speech, André Migueis and Felipe Falção talk about the trauma that lethal police attacks have on relatives and communities. ",
    "videoId": "Kz9V5yoteBI",
    "pubDate": "2017-06-04T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "genocidio",
      "direitoaintegridadefísica",
      "policiaassassina",
      "transportepúblico",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.908592499999997,
    "longitude": -43.22305222222222,
    "title": "Um Trem Para Austin - O Caso Matheus_Full HD",
    "description": "The award-winning short documentary, which tells the story of Matheu’s assassination by police on a train. On his way home to Austin, North of Rio de Janeiro, the 18 year-old was beaten and then shot from short distance by police. The testimony of the parents shows the horrors such a loss has families left behind. ",
    "videoId": "RfJjjwM6iEc",
    "pubDate": "2017-06-20T04:00:00.000Z",
    "producer": [
      "MIC",
      "Mariachi"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Citizenship & Human Rights",
      "Racial Justice & Indigenous Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.908592499999997,
    "longitude": -43.22305222222222,
    "title": "Um trem para Austin - O Caso Matheus(Redux)",
    "description": "The award-winning short documentary, which tells the story of Matheu’s assassination by police on a train. On his way home to Austin, North of Rio de Janeiro, the 18 year-old was beaten and then shot from short distance by police. The testimony of the parents shows the horrors such a loss has families left behind. ",
    "videoId": "4qJ5Smh-69k",
    "pubDate": "2017-09-06T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Other"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Citizenship & Human Rights",
      "Racial Justice & Indigenous Rights"
    ],
    "actors": [
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "direitoaintegridadefísica",
      "paremdenosmatar",
      "policiaassassina",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "501 - 2000",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.11597777777778,
    "longitude": -43.19964611111111,
    "title": "Debate: O encarceramento da juventude negra na UFRRJ/Três Rios",
    "description": "A live streaming video from a meeting about the incarceration of black youth from Favelas in Rio de Janeiro. The event was held the Federal University of Rio de Janeiro/ Três Rios.",
    "videoId": "Acu1CzC39Eo",
    "pubDate": "2017-10-06T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Students",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "desencarceiramento",
      "paremdenosmatar",
      "violenciapolicial",
      "vidasnegrasimportam"
    ],
    "viewCount": "0 - 500",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.96465138888889,
    "longitude": -43.1740425,
    "title": "Pedido de asilo político de advogada no consulado uruguaio no RJ em 2014",
    "description": "Eloisa Samy, lawyer for human rights, questions the process against her and 22 other activists, who were sued for forming an armed movement. The human rights lawyer demands a right to the city for all and an end of the political prosecution of the #23 prisoners of whom she is one. And she explains why she has fled to the embassy of Uruguay to ask for political asylum. ",
    "videoId": "2MQxGvmzW-Q",
    "pubDate": "2018-11-19T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "balasdeborracha",
      "2013",
      "chacina",
      "copa2014",
      "violenciapolicial",
      "direitoamoradia",
      "euapoioos23",
      "liberdadedeexpressão",
      "liberdadeparaospresospolíticos",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -15.799847222222223,
    "longitude": -47.86436694444445,
    "title": "FAMILIARES DE VÍTIMAS DO ESTADO PRESSIONAM INSTITUIÇÕES EM BRASÍLIA",
    "description": "A group of mothers who lost their children to lethal police assaults speak at the House of Representatives (Câmara dos Deputados) in the capital Brasilia. They demand to stop a law that would further strengthen the rights of police officers and further decrease the prosecution of police officers involved in lethal attacks on black, young favela residents. ",
    "videoId": "PHx6I2ofJo4",
    "pubDate": "2019-05-22T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "paremdenosmatar",
      "policiaassassina",
      "protesto",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.908556666666666,
    "longitude": -43.20032666666667,
    "title": "Web-série documental \"Morar é um direito! Ocupar é um dever!\"",
    "description": "The video tells the story of “Ocupa CEDAE”, a residential occupation in the wealthy neighborhood of Flamengo in Rio de Janeiro. The residents of the enormous building fled to Ocupa CEDAE from other places, where they faced forced evictions. Now the forced evictions arrived at Ocupa CEDAE. There are mor empty apartments for real estate speculation than people living on the streets in Brazil as the video claims. ",
    "videoId": "BHfeuGTHl0Q",
    "pubDate": "2019-06-05T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Evictions"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "High"
    ],
    "hashtag": [
      "ColetivoCalisto",
      "AldeiaMaracanã",
      "bastaderacismo",
      "direitoamoradia",
      "ocupa",
      "protesto",
      "remoção",
      "semteto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.899775555555554,
    "longitude": -43.176606388888885,
    "title": "Entrevista com a ativista Buba Aguiar, no ato Vidas Negras Importam",
    "description": "A protest for black live matter in Brazil during the covid pandemic. The live transmission video shows parts of the speech by Buba Aguiar (Coletivo Fala Akari), who says that for black people to stay home during the pandemic does not mean to be safe. Because there is no security for black and poor Brazilians as Buba argues. ",
    "videoId": "QnTiSJrRQik",
    "pubDate": "2020-06-17T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "vidasnegrasimportam",
      "paremdenosmatar",
      "bastaderacismo",
      "saude",
      "protesto",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "PAREM DE NOS MATAR",
    "description": "A mobilizing video for the Black Lives Matter movement in Brazil. ",
    "videoId": "za4xq3p-CPg",
    "pubDate": "2021-05-12T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Protest Documentation"
    ],
    "event": [
      "Street protest",
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Students"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "paremdenosmatar",
      "abusopolicial",
      "genocidio",
      "bastaderacismo",
      "vidasnegrasimportam",
      "violenciapolicial",
      "liberdadedeexpressão",
      "CoalizãoNegra"
    ],
    "viewCount": "0 - 500",
    "videoLength": "0:00-2:00"
  },
  {
    "latitude": -15.798949166666667,
    "longitude": -47.864023611111115,
    "title": "Transmissão ao vivo de Mídia Independente Coletiva",
    "description": "A live coverage of TV, which shows the questioning of a doctor for public health by a member of parliament. ",
    "videoId": "adnfymd2SLM",
    "pubDate": "2021-06-01T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Other"
    ],
    "actors": [],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "covid19",
      "saúde"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.908333,
    "longitude": -43.196388,
    "title": "#Parlatório",
    "description": "The online meeting assembles members of the MIC collective and journalists to discuss the protests on 19 May 2021. The discussants look at the question if the protest march could trigger a new wave of protests like in 2013 and what role independent media collectives may play in this process.  ",
    "videoId": "QKnZz2GaLbQ",
    "pubDate": "2021-06-02T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Other"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "2013",
      "liberdadedeexpressão",
      "protesto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "10:00 and more"
  },
  {
    "latitude": -22.93059416666667,
    "longitude": -43.17863861111111,
    "title": "Arbitrariedade de PMs contra entregadores, advogada e jornalista",
    "description": "The Eyewitness Video; documents the detention of a person at Largo de Marchado in the South Zone of Rio de Janeiro and the outrage this causes with bystanders. According to the original video description a number of people were injured during the arrest and a human rights lawyer was threatened.  ",
    "videoId": "pR1bBAfG95Q",
    "pubDate": "2021-06-04T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Police brutality"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Police"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "abusopolicial",
      "desencarceiramento",
      "protesto",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "5:00-10:00"
  },
  {
    "latitude": -22.904725,
    "longitude": -43.19081,
    "title": "RJ: Deputado bolsonarista discute, ofende e age deforma etnofóbica contra manifestantes em ato no RJ",
    "description": "Rodrigo Amorim, member of parliament of the state of Rio de Janeiro, discusses with activists demanding an end of police violence. The white politician accuses the activists of being “enemies of the police and security”, promises to tear down the indigenous homes at Aldeia Maracanã and then drives of with his bodyguard in a massive black luxury limousine. ",
    "videoId": "Rz94pCpXj2c",
    "pubDate": "2021-06-27T04:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Eyewitness Video"
    ],
    "event": [
      "Street protest"
    ],
    "theme": [
      "Right to the City & Right to Housing",
      "Racial Justice & Indigenous Rights",
      "Women Rights & LGBTQ+ Struggles",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members"
    ],
    "avquality": [
      "Medium"
    ],
    "hashtag": [
      "bandido",
      "bastaderacismo",
      "chacina",
      "fora",
      "paremdenosmatar",
      "policiaassassina",
      "protesto",
      "vidasnegrasimportam",
      "violenciapolicial"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  },
  {
    "latitude": -22.90388361111111,
    "longitude": -43.18922472222222,
    "title": "André De Paula fala em frente Phanteon Duque de Caxias - 25/01/2022",
    "description": "André de Paula, founder of the Frente Internationalista Sem Teto, gives a speech in front of the memorial for Duque de Caxias in which he criticizes the practices of memorizing military leaders, who have committed war crimes. Duque do Caxias was involved in mass killings of slaves in the 19th century. The speech was given during a protest march against the rising public transport costs in Rio de Janeiro. ",
    "videoId": "c20QIDDi01I",
    "pubDate": "2022-01-25T05:00:00.000Z",
    "producer": [
      "MIC"
    ],
    "videoType": [
      "Public Speech and Interview"
    ],
    "event": [
      "Street protest",
      "Police brutality",
      "Lethal Violence"
    ],
    "theme": [
      "Racial Justice & Indigenous Rights",
      "Democratic Representation & Press Freedom",
      "Citizenship & Human Rights"
    ],
    "actors": [
      "Activists & Protest Movements",
      "Residents, Relatives & Community Members",
      "Police",
      "Media"
    ],
    "avquality": [
      "Low"
    ],
    "hashtag": [
      "ditaduranuncamais",
      "foraBolsonaro",
      "genocidio",
      "direitoaotrabalho",
      "protesto",
      "semteto"
    ],
    "viewCount": "0 - 500",
    "videoLength": "2:00-5:00"
  }
];